export default "__VITE_ASSET__PP7rHrXp__"